export async function getKeywordSuggestions(keyword: string) {
  const res = await fetch(`/api/search/keyword-suggestions?q=${keyword}`)
  return res.json()
}
